import AddProductContainer from "../../../../Components/Applications/ECommerce/AddProduct/AddProductContainer";

const AddProduct = () => {
  return <AddProductContainer />;
};

export default AddProduct;
